(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-gallery"] && !Shopify.designMode) return;
  try {
    
class CustomGalleryV3 {
  constructor(container) {
    this.container = container;
    this.galleryItems = Array.from(this.container.querySelectorAll('.gallery-item'));
    this.rowsPerPage = parseInt(this.container.dataset.rowsPerPage, 10);
    this.pageWidth = this.container.querySelector('.page-width');

    this.createLoadMoreButton();
    this.updateImagesPerRow();
    this.updateInitialItems();
    this.initLazyLoad();

    window.addEventListener('resize', () => {
      this.updateImagesPerRow();
      this.updateInitialItems();
      this.observeNextTrigger();
    });
  }

  createLoadMoreButton() {
    this.loadMoreButton = document.createElement('button');
    this.loadMoreButton.className = 'gallery-load-more';
    this.loadMoreButton.textContent = 'Load more';
    this.loadMoreButton.addEventListener('click', () => this.loadMoreItems(true));

    this.pageWidth.after(this.loadMoreButton);
  }

  getCurrentDevice() {
    const width = window.innerWidth;
    if (width >= 990) return 'desktop';
    if (width >= 750) return 'tablet';
    return 'mobile';
  }

  updateImagesPerRow() {
    const styles = getComputedStyle(this.container.querySelector('.gallery-container'));
    this.imagesPerRow = {
      desktop: parseInt(styles.getPropertyValue('--images-per-row-desktop'), 10),
      tablet: parseInt(styles.getPropertyValue('--images-per-row-tablet'), 10),
      mobile: parseInt(styles.getPropertyValue('--images-per-row-mobile'), 10)
    };
  }

  updateInitialItems() {
    const device = this.getCurrentDevice();
    const initialToShow = this.rowsPerPage * this.imagesPerRow[device];
    this.galleryItems.forEach((item, index) => {
      if (index < initialToShow) item.classList.remove('is-hidden');
      else item.classList.add('is-hidden');
    });
    this.toggleLoadMoreButton();
  }

  initLazyLoad() {
    if (this.observer) this.observer.disconnect();

    const observerOptions = { rootMargin: '0px 0px 400px 0px', threshold: 0 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadMoreItems();
          this.observeNextTrigger();
        }
      });
    }, observerOptions);

    this.observeNextTrigger();
  }

  observeNextTrigger() {
    this.observer.disconnect();
    const visibleItems = this.container.querySelectorAll('.gallery-item:not(.is-hidden)');
    const lastVisible = visibleItems[visibleItems.length - 1];
    if (lastVisible) this.observer.observe(lastVisible);
  }

  loadMoreItems(manual = false) {
    const device = this.getCurrentDevice();
    const itemsToReveal = this.imagesPerRow[device];
    const hiddenItems = this.container.querySelectorAll('.gallery-item.is-hidden');

    for (let i = 0; i < itemsToReveal; i++) {
      if (hiddenItems[i]) hiddenItems[i].classList.remove('is-hidden');
    }

    this.toggleLoadMoreButton();

    if (!manual) {
      this.observeNextTrigger();
    }
  }

  toggleLoadMoreButton() {
    const hiddenItems = this.container.querySelectorAll('.gallery-item.is-hidden');
    if (hiddenItems.length === 0) {
      this.loadMoreButton.style.display = 'none';
    } else {
      this.loadMoreButton.style.display = 'block';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.gallery-section').forEach(container => new CustomGalleryV3(container));
});

document.addEventListener('shopify:section:load', (event) => {
  const container = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
  if (container) new CustomGalleryV3(container);
});

  } catch(e) { console.error(e); }
})();
})();
